import React from 'react';
import './BannerImage.css'

const BannerImage = () => {
    return (
        <div className="img-bg">
            <h1 className="text-center">English Premier League</h1>
        </div>
    );
};

export default BannerImage;